// extracted by mini-css-extract-plugin
export default {"root":"SellingParameters_root__0Q5WW","label":"SellingParameters_label__ZtCra"};